export default {
  ActivityFund: 0, // kinh phí hoạt động
  RegularFund: 1, // kinh phí thường xuyên
  IrregularFund: 2, // kinh phí không thường xuyên
  ProjectFund: 3, // kinh phí dự án
  OrderPublicFund: 4, // kinh phí theo đơn đặt hàng nhà nước
  BasicConstructFund: 5, // kinh phí xây dựng cơ bản
  InvestmentFund: 6, // kinh phí tổng điều tra
  PriorityFund: 7, // kinh phí ưu đãi người có công
  NotReturnFund: 8, // kinh phí viện trợ không hoàn lại
  DebtForeignFund: 9 // kinh phí vay nợ nước ngoài
};
